// i18n area 'auth' — locale sv-SE (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/auth.sv-SE.meta.json.
import type { enUS } from './auth'

export const svSE: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Logga in på ditt konto',
    username: 'Användarnamn',
    usernamePlaceholder: 'Ange användarnamnet',
    usernameHint: 'Använd användare@domän för att autentisera dig mot ett directory-realm',
    continue: 'Fortsätt',
    changeUser: 'Inte du?',
    password: 'Lösenord',
    forgotPassword: 'Glömt lösenordet?',
    submit: 'Logga in',
    otp: 'Engångskod',
    otpSubtitle: 'Ange koden från din autentiserare',
    otpHint: 'Sex siffror från autentiseringsappen, eller en av återställningskoderna',
    otpSubmit: 'Verifiera',
    invalidCredentials: 'Ogiltigt användarnamn eller lösenord',
    tooManyAttempts: 'För många försök — vänta en stund och försök igen',
    realmUnavailable: 'Realmet kan inte verifiera uppgifterna just nu — klustrets store är inte nåbar. Logga in som lokal användare (break-glass).',
    genericError: 'Inloggningen misslyckades — är TVirt-backenden nåbar?'
  },
  user: {
    logout: 'Logga ut',
    password: {
      menu: 'Byt lösenord',
      title: 'Byt ditt lösenord',
      current: 'Nuvarande lösenord',
      new: 'Nytt lösenord',
      confirm: 'Bekräfta det nya lösenordet',
      mismatch: 'Lösenorden stämmer inte överens',
      error: 'Kunde inte byta lösenordet',
      forcedTitle: 'Byt lösenordet för att fortsätta',
      forcedHint: 'Det här lösenordet sattes av en administratör och måste ersättas innan du kommer in.',
      forcedSubmit: 'Byt och logga in'
    },
    mfa: {
      title: 'Tvåfaktorsautentisering',
      subtitle: 'En andra faktor krävs vid varje inloggning',
      loadError: 'Kunde inte läsa in den andra faktorns status',
      enrolled: 'Aktiv',
      notEnrolled: 'Inte aktiv',
      enrolledAt: 'Aktiverad den',
      codesRemaining: 'Återstående återställningskoder',
      requiredHint:
        'En administratör kräver en andra faktor på det här kontot: konfigurera den nu — tills du gör det kan du logga in, men inte mycket mer.',
      enroll: 'Konfigurera',
      enrollTitle: 'Konfigurera tvåfaktorsautentiseringen',
      enrollHint: 'Skanna den här koden med autentiseringsappen och skriv sedan in koden den visar för att bekräfta.',
      secretHint: 'Kan du inte skanna den? Skriv in den här hemligheten i appen:',
      code: 'Kod från appen',
      confirm: 'Bekräfta',
      startError: 'Kunde inte starta konfigurationen',
      confirmError: 'Kunde inte bekräfta konfigurationen',
      codesTitle: 'Dina återställningskoder',
      codesWarning:
        'De här koderna visas bara en enda gång. Spara dem nu: var och en släpper in dig när autentiseraren inte är tillgänglig, och gäller en enda gång.',
      codesAck: 'Jag har sparat återställningskoderna',
      codesDone: 'Klart',
      copy: 'Kopiera',
      copied: 'Kopierad',
      download: 'Ladda ner',
      regenerate: 'Nya återställningskoder',
      regenerateTitle: 'Generera om återställningskoderna',
      regenerateHint: 'Alla hittills utfärdade koder slutar fungera i samma ögonblick som den nya uppsättningen genereras.',
      regenerateConfirm: 'Generera om',
      regenerateError: 'Kunde inte generera om återställningskoderna',
      remove: 'Ta bort',
      removeTitle: 'Ta bort den andra faktorn',
      removeConfirm: 'Ta bort',
      removeHint: 'Kontot återgår till enbart lösenord. Du kan konfigurera den andra faktorn igen när du vill.',
      removeRequiredHint:
        'En administratör kräver en andra faktor på det här kontot, så servern kommer att avvisa borttagningen — be om att kravet tas bort först.',
      removeError: 'Kunde inte ta bort den andra faktorn'
    },
    profile: {
      menu: 'Gå till min profil',
      sessions: 'Aktiva sessioner',
      sessionsHint: 'Dina öppna sessioner på den här noden',
      sessionsEmpty: 'Ingen aktiv session',
      sessionCreated: 'Inloggad',
      sessionExpires: 'Går ut',
      revoke: 'Återkalla sessionen',
      revokeError: 'Kunde inte återkalla sessionen',
      loadError: 'Kunde inte läsa in sessionerna'
    }
  }
}
